import{g as globalScript}from"./global-f07c13ad.js";var globalScripts=globalScript;export{globalScripts as g};